// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-bjP8GS","control":"control-o9NhW7"};